import { Component, OnDestroy, Input, OnChanges } from '@angular/core';
import { ActiveCall, CallTimers } from 'app/models/dto/call.model';

@Component({
  selector: 'softphone-timer',
  templateUrl: './softphone-timer.component.html',
  styleUrls: ['./softphone-timer.component.scss'],
  standalone: false
})
export class SoftphoneTimerComponent implements OnChanges, OnDestroy {

    @Input() activeCall: ActiveCall;
    @Input() callTimers: CallTimers;

    counter = 0;
    timerRef;
    running = false;
    callTimer: number;

    ngOnChanges() {
        this.running = this.activeCall.inProgress ?? false;
        this.callTimer = this.activeCall.callId ? this.callTimers[this.activeCall.callId] : 0;
        this.startTimer();
    }

    startTimer() {
        this.resetTimer();
        if (this.running && this.callTimer !== 0) {
            const tick = () => { this.counter = Date.now() - this.callTimer; };
            tick();
            this.timerRef = setInterval(tick, 1000);
        } else {
            clearInterval(this.timerRef);
        }
    }

    resetTimer() {
        this.counter = 0;
        clearInterval(this.timerRef);
    }

    ngOnDestroy() {
        clearInterval(this.timerRef);
    }

}
